<template>
	<div>
		<header
			class="app-top-bar u-container"
			:class="{ 'app-top-bar--bottom-line': isBottomLine }"
		>
			<div class="app-top-bar__util">
				<i
					v-if="isHistory"
					@click="$router.go(-1)"
					class="ri-arrow-left-line"
				></i>
			</div>
			<h1>{{ title }}</h1>
			<div class="app-top-bar__util app-top-bar__util--info">
				<i
					v-if="isPageInfo"
					@click="$emit('info-click', $event)"
					class="ri-information-fill"
				></i>
			</div>
		</header>
	</div>
</template>

<script>
export default {
	data() {
		return {};
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		isHistory: {
			type: Boolean,
			default: false,
		},
		isPageInfo: {
			type: Boolean,
			default: false,
		},
		isBottomLine: {
			type: Boolean,
			default: true,
		},
	},
};
</script>

<style scoped>
.app-top-bar {
	position: fixed;
	left: 0;
	right: 0;
	z-index: 7500;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 3.25rem;
	background: #fff;
	box-sizing: content-box;
	padding-top: constant(safe-area-inset-top); /* iOS 11.0 버전 */
	padding-top: env(safe-area-inset-top); /* iOS 11.2 이상 */
}

.app-top-bar--bottom-line::after {
	content: '';
	position: absolute;
	left: 1rem;
	right: 1rem;
	bottom: 0;
	height: 2px;
	background: #222;
}

.app-top-bar__util {
	flex: 0 0 1.5rem;
	text-align: center;
}

.app-top-bar i {
	font-size: 1.125rem;
}

.app-top-bar__util--info i {
	font-size: 1.375rem;
}

.app-top-bar h1 {
	font-size: 1.0625rem;
}
</style>
